<template>
  <footer class="github-footer">
    <a class="footer-link" href="https://github.com/cresentboy/online-resume"
      >项目库托管在Github</a
    >
  </footer>
</template>
<script>
export default {
  name: "foot",
  data() {
    return {};
  },
  computed: {},
  mounted() {}
};
</script>



// WEBPACK FOOTER //
// src/components/common/foot.vue